import { Input } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'
import { CustomerAddressInputFieldProps } from '../../types/customerAddressInputFieldProps'

type CustomerPoboxProps = CustomerAddressInputFieldProps

export const CustomerPobox = ({ isDisabled = false }: CustomerPoboxProps) => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.address.pobox.label')}
      name="address.pobox"
      render={({ field }) => {
        return <Input {...field} disabled={isDisabled} size="sm" />
      }}
    />
  )
}
